import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SharedService } from "@shared/services/shared.service";
import { IBusiness, IBusinessEnclosedAreasViewModel } from "app/models/business/business";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { IBusinessExemptInspectionsViewModel } from "app/models/mainMenu/mainMenu";
import { AuthService } from "@shared/auth/auth.service";
import { ReportEnclosedAreaComponent } from "./reportEnclosedArea/reportEnclosedArea.component";
import { IEnclosedAreaEditHistory } from "app/models/reports/reports";
import { EnclosedAreaFileComponent } from "./enclosedAreaFile/enclosedAreaFile.component";
import { EnclosedAreaEditComponent } from "./enclosedAreaEdit/enclosedAreaEdit.component";
import { EnclosedAreaHistoryComponent } from "./enclosedAreaHistory/enclosedAreaHistory.component";
import { EnclosedAreaAttachmentComponent } from "./enclosedAreaAttachment/enclosedAreaAttachment.component";
// import { subscriptionLogsToBeFn } from "rxjs/internal/testing/TestScheduler";
import { Subscription } from "rxjs";



@Component({
  selector: 'shared-sharedEnclosedArea',
  styleUrls: ['./sharedEnclosedArea.component.scss'],
  templateUrl: './sharedEnclosedArea.component.html'
})

export class SharedEnclosedAreaComponent implements OnInit {

  // Called from either the Complaint(0) or Business(1) components
  @Input() parentPanel: number = 0;

  sharedSubscription: Subscription;
  currentBusiness: IBusiness = {} as IBusiness;
  enclosedAreaList: IEnclosedAreaEditHistory[] = [];
  enclosedArea: IBusinessEnclosedAreasViewModel = {} as IBusinessEnclosedAreasViewModel;
  currentEnclosedArea: IEnclosedAreaEditHistory = {} as IEnclosedAreaEditHistory;

  businessId: number = 0;
  isAdmin: boolean = false;

  panelParent: string = '';

  displayedColumns: string[] = ['action', 'complaintId', 'visitDate', 'comments', 'enclosedArea', 'enclosedAreaDetermination',
    'enclosedAreaDeterminationComments', 'editHistory', 'files'];
  dataSource = new MatTableDataSource<IEnclosedAreaEditHistory>(this.enclosedAreaList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private complaintService: ComplaintService,
    private authService: AuthService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    if (this.parentPanel == 0) {
      this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
        if (data == 5) {
          this.businessId = this.complaintService.currentComplaint.businessId;
          this.getEnclosedArea();
        }
      });
    } else {
      this.sharedSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
        if (data == 4) {
          this.businessId = this.businessService.businessId;
          this.getEnclosedArea();
        }
      });
    }

    this.isAdmin = this.authService.isAdmin;
    this.panelParent = this.parentPanel == 0 ? 'complaint' : 'business';
  }

  ngOnDestroy() {
    this.sharedSubscription.unsubscribe();
  }

  getEnclosedArea() {
    this.complaintService.getEnclosedArea(this.businessId).subscribe({
      next: response => {
        this.enclosedArea = response;
        this.currentEnclosedArea = this.enclosedArea.currentEnclosedArea;
        this.dataSource.data = this.enclosedArea.enclosedAreaHistory;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Enclosed Area Info");
      },
    });
  }

  deleteInspection(inspection: IBusinessExemptInspectionsViewModel) {
    this.sharedService.openConfirm("Are you sure you want to delete this inspection?");
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.businessService.removeInspection(inspection.businessFollowupSiteVisitId).subscribe({
            next: response => {
              this.sharedService.toastr.success("Inspection Deleted");
              this.getEnclosedArea();
            },
            error: e => {
              this.sharedService.toastr.error("Could not delete Inspection");
            },
          });
        }
      }
    );
  }

  addFile(area: IEnclosedAreaEditHistory) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 400;
    config.maxHeight = 600;
    config.data = {
      enclosedAreaId: area.id,
    };
    const dialogRef = this.modalService.open(EnclosedAreaFileComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getEnclosedArea();
        }
      },
      error => this.sharedService.toastr.error("Could not add Enclosed Area File: " + error.message),
      () => { }
    );    
  }

  editArea(area: IEnclosedAreaEditHistory) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 400;
    config.maxHeight = 600;
    config.data = {
      enclosedArea: area,
    };
    const dialogRef = this.modalService.open(EnclosedAreaEditComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getEnclosedArea();
        }
      },
      error => this.sharedService.toastr.error("Could not add Edit Enclosed Area: " + error.message),
      () => { }
    );    
  }

  showFiles(area: IEnclosedAreaEditHistory) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.maxHeight = 600;
    config.data = {
      filesList: area.files
    };
    const dialogRef = this.modalService.open(EnclosedAreaAttachmentComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'deleted') {
          this.getEnclosedArea();
        }
      },
      error => this.sharedService.toastr.error("Could not add Enclosed Area File: " + error.message),
      () => { }
    );
  }

  showHistory(area: IEnclosedAreaEditHistory) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.maxHeight = 600;
    config.data = {
      history: area.editHistory
    };
    const dialogRef = this.modalService.open(EnclosedAreaHistoryComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {

      },
      error => this.sharedService.toastr.error("Could not add Enclosed Area File: " + error.message),
      () => { }
    );
  }

  reportEnclosedArea(inspection: IBusinessExemptInspectionsViewModel = null) {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.maxHeight = 600;
    config.data = {
      enclosedArea: this.currentEnclosedArea,
      businessId: this.businessId
    };
    const dialogRef = this.modalService.open(ReportEnclosedAreaComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getEnclosedArea();
        }
      },
      error => this.sharedService.toastr.error("Could not add Enclosed Area Info: " + error.message),
      () => { }
    );
  }

}